import { useRegisterSW } from 'virtual:pwa-register/react';
import { Banner } from '@/components/Banner';
import { Button } from '@/components/Button';

/**
 * Aviso de version nueva disponible (Req. 2.5).
 *
 * El complemento esta configurado con `registerType: 'prompt'` y no
 * 'autoUpdate' justamente para esto: la aplicacion avisa y pide confirmacion
 * antes de recargar, en lugar de recargar sola mientras se captura algo.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [necesitaActualizar, setNecesitaActualizar],
    updateServiceWorker,
  } = useRegisterSW();

  if (!necesitaActualizar) return null;

  return (
    <Banner
      tono="info"
      titulo="Hay una version nueva de la aplicacion"
      accion={
        <div className="flex gap-2">
          <Button
            variante="primario"
            completo={false}
            onClick={() => {
              void updateServiceWorker(true);
            }}
          >
            Actualizar ahora
          </Button>
          <Button
            variante="secundario"
            completo={false}
            onClick={() => setNecesitaActualizar(false)}
          >
            Despues
          </Button>
        </div>
      }
    >
      Al actualizar se recarga la aplicacion. Tus datos no se tocan.
    </Banner>
  );
}
